import { Component, HostBinding, Inject, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { IModalsService, IMODALS_SERVICE, P500UIBaseModal, TooltipDirective } from '@platform500services/p500-ui-kit';
import { ClipboardServiceInterface } from '../../services/clipboard/clipboard-service.interface';
import { Router } from '@angular/router';

@Component({
  templateUrl: './info.modal.html',
})
export class InfoModal extends P500UIBaseModal implements OnInit, OnDestroy {
  @Input() data: InfoModalData;
  @Input() onClose: () => void = () => {};
  @Input() onFooterClose: () => void = () => {};

  @ViewChild(TooltipDirective) tooltipDirective: TooltipDirective;
  @ViewChild('footerRef', { read: ViewContainerRef }) footerRef: ViewContainerRef;

  @HostBinding('class') get className() {
    return `p500-ui-modal p500-ui-modal--primary p500-ui-modal--${this.data?.size || 'small'} c-modal c-modal--info`;
  }

  public prettyBodyText = '';
  private timeout: any;
  public modalType: string;
  public MODAL_TYPES = ModalType;
  public footerType: string;
  public FOOTER_TYPES = FooterType;

  constructor(
    @Inject(IMODALS_SERVICE) public modalsService: IModalsService,
    @Inject('ClipboardServiceInterface') private clipboardService: ClipboardServiceInterface,
    router: Router
  ) {
    super(modalsService, router);
  }

  ngOnInit(): void {
    this.modalType = this.data.modalType;
    try {
      const parsedBodyText = JSON.parse(this.data.body);
      this.prettyBodyText = JSON.stringify(parsedBodyText, null, 2).trim();
    } catch {
      this.prettyBodyText = this.data.body;
    }
  }

  closeModal(): void {
    this.onClose();
    this.modalsService.close(this.uniqueId);
  }

  footerCancel = () => this.modalsService.close(this.uniqueId);

  public copy(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    this.clipboardService.copyFromContent(this.prettyBodyText);
    this.tooltipDirective.updateText($localize`:@@common.copied_to_clipboard:Copied to clipboard`);
    this.timeout = setTimeout(() => {
      this.tooltipDirective.updateText($localize`:@@common.copy_to_clipboard:Copy to clipboard`);
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}

enum ModalType {
  'INFO' = 'INFO',
  'DANGER' = 'DANGER',
}

enum FooterType {
  'CLOSE_CANCEL' = 'CLOSE_CANCEL',
}

export const INFO_MODAL_DATA: { [key: string]: InfoModalData } = {
  REGISTRATION: {
    title: $localize`:@@common.are_you_sure:Are you sure?`,
    subTitle: '',
    body: $localize`:@@signup.registration_not_finished_warning:The registration was not completed. Are you sure you want to leave the page?`,

    modalType: ModalType.INFO,
    footerType: FooterType.CLOSE_CANCEL,
    hasCopy: false,
  },
  OFFER_DESCRIPTION: {
    title: $localize`:@@common.description:Description`,
    subTitle: '',
    modalType: ModalType.INFO,
    body: '',
    footerType: null,
    hasCopy: false,
    size: 'medium',
  },
  CURRENCY_SELECT: {
    title: $localize`:@@common.help_information:Help Information`,
    subTitle: '',
    body: $localize`:@@common.currency_select_tooltip:View only the relevant data for your selected currency. Currently, there is no united report available for multiple currencies. To explore other data, switch to a different currency.`,
    footerType: null,
    hasCopy: false,
    class: '-info',
  },
};

export interface InfoModalData {
  title: string;
  subTitle: string;
  body: string;
  modalType?: ModalType;
  footerType: FooterType | null;
  hasCopy: boolean;
  size?: 'small' | 'medium' | 'large';
  class?: string;
}
